import { tv } from "tailwind-variants";

const classes = tv({
  slots: {
    base: "w-6 h-6 aspect-square px-[3px] py-[5px] rounded-xs outline-solid outline-1 -outline-offset-1 inline-flex flex-col justify-center items-center gap-2 overflow-hidden transition-colors cursor-pointer select-none"
  },
  variants: {
    color: {
      default: 'outline-gray-300 text-gray-500 bg-gray-100 hover:text-primary-500 hover:bg-primary-100 hover:outline-primary-500 ',
      primary: 'outline-white text-white bg-primary-400 hover:text-primary-500 hover:bg-primary-100 hover:outline-primary-500',
    }
  }
});




export const ChatButton = defineComponent<{
  variant?: MaybeRef<'default' | 'primary'>;
  onClick?: any;
}>((props, ctx) => {
  const variant = computed(() => unref(props.variant))
  const clazz = classes({
    color: variant.value || 'default'
  })
  return () => {
    return (
      <div class={clazz.base({ color: variant.value || 'default' })}>
        {ctx.slots.default ? ctx.slots.default() : ''}
      </div>
    );
  };
}, { props: ['variant'] });
